module.exports = __webpack_public_path__ + "static/media/pic8@2x.1d1b1c4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_146/img/pic8@2x.png
// module id = 1401
// module chunks = 0